import * as v from "valibot";

export const getFanCreatorsRpcContract = {
  name: "get-fan-creators",
  paramsSchema: v.object({
    limit: v.optional(v.pipe(v.number(), v.minValue(1), v.maxValue(100)), 20),
    offset: v.optional(v.pipe(v.number(), v.minValue(0)), 0),
    search: v.optional(v.string()),
  }),
  resultSchema: v.object({
    influencers: v.array(
      v.object({
        id: v.string(),
        handle: v.nullable(v.string()),
        profileImage: v.nullable(v.string()),
        profileImagePath: v.nullable(v.string()),
        bio: v.nullable(v.string()),
        isFollowed: v.boolean(),
      }),
    ),
    totalCount: v.number(),
    hasMore: v.boolean(),
  }),
} as const;

export type GetFanCreatorsParams = v.InferInput<typeof getFanCreatorsRpcContract.paramsSchema>;
export type GetFanCreatorsResult = v.InferOutput<typeof getFanCreatorsRpcContract.resultSchema>;
